import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PricingService {
    private readonly _httpClient = inject(HttpClient);
    constructor() {}

    /**
     * Maps to: app.MapPost("/merchants/validate-pricing", ...)
     */
    validatePricing(payload: any): Observable<any> {
        return this._httpClient.post(`${environment.apiUrl}/merchants/validate-pricing`, payload);
    }

    /**
     * Maps to: app.MapPost("/merchants/pricing", ...)
     */
    savePricing(payload: any): Observable<any> {
        if (payload.pricingTableId) {
            return this._httpClient.put(`${environment.apiUrl}/merchants/${payload.pricingTableId}/pricing`, payload);
        } else {
            return this._httpClient.post(`${environment.apiUrl}/merchants/pricing`, payload);
        }
    }

    getPricing(merchantApiId: string): Observable<any> {
        return this._httpClient.get(`${environment.apiUrl}/merchants/${merchantApiId}/pricing`);
    }

    /**
     * Maps to MapDelete("merchants/pricing/{pricingTableId}")
     */
    deletePricing(pricingTableId: string): Observable<any> {
        return this._httpClient.delete(`${environment.apiUrl}/merchants/pricing/${pricingTableId}`);
    }

    // getPricing(merchantId: string): Observable<any> {
    //     console.log(merchantId);
    //     return of(PRICING_MOCKDATA);
    // }
}

const PRICING_MOCKDATA = {
    isSuccess: true,
    code: 'OK',
    data: [
        {
            pricingTableId: 4395,
            pricingType: 'TIERED_PRICING',
            isCustom: false,
            pricingRanges: [
                {
                    id: 10598,
                    minimum: 0.0,
                    maximum: 49999.99,
                    fee: 0.021920188,
                    pricingTableId: 4395,
                },
                {
                    id: 10599,
                    minimum: 50000.0,
                    maximum: 99999.99,
                    fee: 0.019627836,
                    pricingTableId: 4395,
                },
                {
                    id: 10600,
                    minimum: 100000.0,
                    fee: 0.018485512,
                    pricingTableId: 4395,
                },
            ],
        },
        {
            label: 'Custom 1',
            pricingTableId: 4395,
            pricingType: 'SINGLE_PRICING',
            isCustom: true,
            pricingRanges: [
                {
                    id: 10598,
                    minimum: 0.0,
                    maximum: null,
                    fee: 0.021920188,
                    pricingTableId: 4395,
                },
            ],
        },
    ],
};
